import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import MainLayout from "../../layouts/main/main_layout";
import { useNavigate } from "react-router-dom";
import { black } from "../../theme/colors";

const buttonItems = [
  { label: "Hourly Report", key: "hourly-report" },
  { label: "Lat/Long", key: "lat-long" },
  { label: "FM Portal", key: "fm-portal" },
  { label: "Live Project", key: "live-project" },
  { label: "Quality Backcheck", key: "quality-backcheck" },
  { label: "HRMIS Gift Data", key: "hrmis-gift-data" },
  { label: "Time Duration of Each Survey", key: "time-duration-survey" },
];

export default function FmPortal() {
  const navigate = useNavigate();

  const handleClick = (key: string) => {
    if (key === "hourly-report") {
      navigate("/fm-portal/hourly-report");
    }
  };

  return (
    <MainLayout>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="70vh"
        width="100%"
      >
        <Card
          sx={{
            maxWidth: 800,
            width: "100%",
            px: 4,
            py: 3,
            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.08)",
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ p: 0 }}>
            <Typography
              variant="h6"
              textAlign="center"
              mb={3}
              color={black}
              fontWeight={600}
            >
              FM Portal
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              {buttonItems.map((item) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  key={item.key}
                  display="flex"
                  justifyContent="center"
                >
                  <Button
                    variant="contained"
                    sx={{ minWidth: 200 }}
                    onClick={() => handleClick(item.key)}
                  >
                    {item.label}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </MainLayout>
  );
}

